import { getRentalPortalProfileTabCount } from '../../RentalPortal.utils'
import { RentalPortalApplicantProfileDocuments } from '../RentalPortalApplicantProfileDocuments'
import { RentalPortalApplicantProfileEmails } from '../RentalPortalApplicantProfileEmails'
import { RentalPortalApplicantProfileTabOverview } from '../RentalPortalApplicantProfileTabOverview'
import { RentalPortalApplicantProfileUpdates } from '../RentalPortalApplicantProfileUpdates'

import { APPLICANT_PROFILE_TAB } from './RentalPortalApplicantProfileTabs.constants'

export function getApplicantProfileTabCounters(counts) {
  return {
    [APPLICANT_PROFILE_TAB.emails]: {
      total: getRentalPortalProfileTabCount(counts?.emails),
    },
  }
}

export function getApplicantProfileTabContent({ activeTabId, applicantId }) {
  switch (activeTabId) {
    case APPLICANT_PROFILE_TAB.documents:
      return <RentalPortalApplicantProfileDocuments />
    case APPLICANT_PROFILE_TAB.emails:
      return <RentalPortalApplicantProfileEmails key={applicantId} />
    case APPLICANT_PROFILE_TAB.overview:
      return <RentalPortalApplicantProfileTabOverview />
    case APPLICANT_PROFILE_TAB.updates:
      return <RentalPortalApplicantProfileUpdates />
    default:
      return null
  }
}
